<ul class="mb-4" [formGroup]="visualizationConfig">
    <li class="mb-2" formGroupName="maturity">{{'variables.maturity' | translate}}:
        <div class="flex gap-4">
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="app" inputId="app" [binary]="true"/>
                <label for="app" class="text-sm">{{'projects.visualizationConfig.app' | translate}}</label>
            </div>
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="report" inputId="report" [binary]="true"/>
                <label for="report" class="text-sm">{{'projects.visualizationConfig.report' | translate}}</label>
            </div>
        </div>
    </li>
    <li class="mb-2" formGroupName="maturityThreshold">{{'projects.visualizationConfig.requirements' | translate}} - {{'variables.maturity' | translate}}:
        <div class="flex gap-4">
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="app" inputId="maturity-req-app" [binary]="true"/>
                <label for="maturity-req-app" class="text-sm">{{'projects.visualizationConfig.app' | translate}}</label>
            </div>
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="report" inputId="maturity-req-report" [binary]="true"/>
                <label for="maturity-req-report" class="text-sm">{{'projects.visualizationConfig.report' | translate}}</label>
            </div>
        </div>  
    </li>
    <li class="mb-2" formGroupName="relativeMaturity">{{'variables.relativeMaturity' | translate}} (experimental):
        <div class="flex gap-4">
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="app" inputId="rel-maturity-app" [binary]="true"/>
                <label for="rel-maturity-app" class="text-sm">{{'projects.visualizationConfig.app' | translate}}</label>
            </div>
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="report" inputId="rel-maturity-report" [binary]="true"/>
                <label for="rel-maturity-report" class="text-sm">{{'projects.visualizationConfig.report' | translate}}</label>
            </div>
        </div>
    </li>
    <li class="mb-2" formGroupName="relativeMaturityThreshold">{{'projects.visualizationConfig.requirements' | translate}} - {{'variables.relativeMaturity' | translate}} (experimental):
        <div class="flex gap-4">
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="app" inputId="rel-maturity-req-app" [binary]="true"/>
                <label for="rel-maturity-req-app" class="text-sm">{{'projects.visualizationConfig.app' | translate}}</label>
            </div>
            <div class="flex items-center gap-2">
                <p-checkbox formControlName="report" inputId="rel-maturity-req-report" [binary]="true"/>
                <label for="rel-maturity-req-report" class="text-sm">{{'projects.visualizationConfig.report' | translate}}</label>
            </div>
        </div>
        
    </li>
</ul>

<div class="w-full text-center">
    <button pButton (click)="updateProject(visualizationConfig)">{{ ('button.save') | translate}}</button>
</div>
